import { Button, CCheckbox } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate, useNavigateStackCustom } from "core/hooks/useCustomNavigate";
import { RouterName, route } from "core/router";
import { useEffect, useState } from "react";
import ArrowRight from 'core/assets/icons/menu/arrow_r.svg';
import { _t } from "core/language";
import { useLocation } from "react-router-dom";
import { useLoginClient } from "../hooks";
import { useAuthModal } from "core/context";


const SignUpPolicy = () => {
  const navigate = useCustomNavigate();
  const location = useLocation();
  
  const [dataForm, setDataForm] = useState<any>({
    termOfUse: false,
    privacyPolicy: false,
  });
  const [checkAll, setCheckAll] = useState(false);
  const [urlBackPage, setUrlBackPage] = useState('');
  const [loginModal, setLoginModal] = useState({state:false,dataSns:''});
  const [signUpModal, setSignUpModal] = useState({state:false});
  const [loginPage, setLoginPage] = useState({state:false,dataSns:''});
  const { getLastRoute } = useNavigateStackCustom();

  const { callPrevAction } = useAuthModal()
  const _onSuccess = () => {
    localStorage.removeItem('dataSns')
    const lastRoute = getLastRoute(true);
    console.log(lastRoute,'lastRoute policy')
    if(loginPage?.state){
      navigate(lastRoute)
      callPrevAction?.()
      // navigate(-2)
    }else {
      navigate(-1)
      callPrevAction?.()
    }
    
  };

  const _onFailed = (errors: any) => {
    console.log(errors)
  };

  const {handleLogin} = useLoginClient({
    onSuccess: _onSuccess,
    onFailed: _onFailed,
  });

  useEffect(() => {
    setCheckAll(dataForm.termOfUse && dataForm.privacyPolicy);
  }, [dataForm])

  useEffect(() => {
    const dataPolicy = localStorage.getItem('dataPolicy');
    if(dataPolicy){
      setDataForm(JSON.parse(dataPolicy))
    }
    if(location?.search && location?.search.includes('backPage')){  
      const url = new URLSearchParams(location?.search).get('backPage');
      if(url){
        setUrlBackPage(url)
      }
    }
    if(location?.search && location?.search.includes('loginModal')){  
      const dataSns = localStorage.getItem('dataSns');
      setLoginModal({state:true,dataSns:JSON.parse(dataSns || '')})
    }
    if(location?.search && location?.search.includes('signUpModal')){  
      setSignUpModal({state:true})
    }
    if(location?.search && location?.search.includes('loginPage')){  
      const dataSnsPage = localStorage.getItem('dataSns');
      setLoginPage({state:true,dataSns:JSON.parse(dataSnsPage || '')})
    }
  }, [location])
  
  const handleGoBack = () => {
    navigate(-1)
  }

  const handleToPolicyPage = (url: any) => {
    localStorage.setItem('dataPolicy', JSON.stringify(dataForm))
    navigate(route(url))
  }

  const renderContentPrivacyPolicy = () => {
    return (<div className="relative block w-full"> <p
        onClick={() => handleToPolicyPage(RouterName.PRIVACY_POLICY)} 
        className="icon-policy text-[14px] font-medium">
        <span dangerouslySetInnerHTML={{ __html: _t('auth.PrivacyPolicy') }} />
        {ArrowRight && <img loading="lazy" src={ArrowRight || ''} alt={'ArrowRight'} className="object-contain shrink-0 aspect-square absolute right-0 top-[4px]" /> }
      </p>
    </div>)
  }

  const renderContentTermOfUse = () => {
    return (<div className="relative block w-full"> <p
        onClick={() => handleToPolicyPage(RouterName.TERM_OF_USE)} 
        className="icon-policy text-[14px] font-medium">
        <span dangerouslySetInnerHTML={{ __html: _t('auth.TermOfUse') }} />
        {ArrowRight && <img loading="lazy" src={ArrowRight} alt={'ArrowRight'} className="object-contain shrink-0 aspect-square absolute right-0 top-[4px]" /> }
      </p>
    </div>)
  }
  
  const handleToPage = (url: any) => {
    const stateToSignUp = loginModal?.state || loginPage?.state
    if(stateToSignUp){
      handleLogin(loginModal?.dataSns || loginPage?.dataSns)
    }else {
      navigate(route(url+`${signUpModal.state ? '?signUpModal=true' : ''}`)+`${urlBackPage ? '?signUpByMenu='+urlBackPage : ''}`)
    }
  }
  
  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader sticky showCart={false} title={_t('auth.LabelCondition')} handleGoBack={handleGoBack} />
      <div className="mt-1">
        <section className="flex flex-col px-4 py-[50px] w-full tracking-tighter bg-white">
          <CCheckbox
            className=""
            label={_t('auth.FullAgreement')}
            checked={checkAll}
            onChange={(value: boolean) => {
              setCheckAll(value);
              setDataForm({
                termOfUse: value,
                privacyPolicy: value,
              })
            }}
            rounded
          />
          <div className="shrink-0 mt-[32px] h-[1px] bg-[#eeeeee]" />
          <div className="mt-8">
            <div className="flex gap-2  w-full mb-6">
              <CCheckbox
                className=""
                label={``}
                checked={dataForm.termOfUse}
                onChange={(value: boolean) => { setDataForm({ ...dataForm, termOfUse: value }) }}
                rounded
              />
              {renderContentTermOfUse()}
            </div>
            <div className="flex gap-2  w-full mb-6">
              <CCheckbox
                className=""
                label={``}
                checked={dataForm.privacyPolicy}
                onChange={(value: boolean) => { setDataForm({ ...dataForm, privacyPolicy: value }) }}
                rounded
              />
              {renderContentPrivacyPolicy()}
            </div>
          </div>
          <div className="absolute left-0 bottom-0 w-full px-4">
            <Button size="lg" label={_t('auth.Next')} disabled={!checkAll} onClickBtn={() => handleToPage(RouterName.SIGNUP_FORM)} classBtn="w-full mb-[50px] font-medium" />
          </div>
        </section>
      </div >

    </AppLayout >
  );
};

export default SignUpPolicy;
